import React, { useEffect } from 'react';  
import Home from './Home';
import Intropage from '../pages/Intropage/Intropage';
import { useDispatch, useSelector } from "react-redux";
import { GenderData } from "../action";


export default function Landing() { 
    const dispatch = useDispatch();
    const genderData = useSelector(state=>state.category?.gender); 
    localStorage.setItem("myPage",0);

    // Visiting `/` should always show the intro page.
    // Clear any previously selected gender (e.g. after Back from /female).
    useEffect(() => {
      if (genderData) dispatch(GenderData(null));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  return (
    <>
    {(genderData ? <Home/> : <Intropage/>)}
    </>
  )
}
